var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEmailIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 18 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.189.369A2.493 2.493 0 0 0 .7 2.859v8.301c0 1.375 1.12 2.49 2.489 2.49h11.623a2.493 2.493 0 0 0 2.488-2.49V2.859c0-1.375-1.12-2.49-2.489-2.49H3.19Zm-.75 2.143a.827.827 0 0 1 .75-.483h11.623c.33 0 .62.198.75.483l-6.057 4.71a.816.816 0 0 1-1.01 0L2.44 2.512Zm-.08 2.045v4.831l2.998-2.499L2.36 4.557Zm.07 6.934a.83.83 0 0 0 .76.499h11.623a.83.83 0 0 0 .76-.499l-4.268-3.559-.78.6c-.9.7-2.149.7-3.048 0l-.78-.6-4.267 3.559Zm13.212-2.103V4.557l-2.998 2.332 2.998 2.499Z",
  fill: "currentColor"
})));
export default SvgEmailIcon;